<template>
    <div class="history">
        <div class="coverBgc">
            <img src="../../assets/about/bgc.png" alt="">
            <div class="titleText">
                <div class="title">
                    <div>培养学习型民族精神</div>
                    <div>铸造创新型中华文化</div>
                </div>
                <div class="explain">
                    于教育大数据的思维，中潮教育以创建企业书院为形式，以提升职业能力为核心，以推动职业人才培养为目标，低成本地帮助企业建设线上与线下相结合、学历与非学历相结合、知识与技能相结合的“直教直学”学习系统。
                </div>
            </div>
        </div>
        <div class="historyContent">
            <div class="historyTitle">发展历程</div>
            <div class="historyList">
                <div class="historyListItem" v-for="(item,index) in list" :key="index">
                    <div class="historyListItemImg">
                        <img src="../../assets/news/step.png" alt="">
                    </div>
                    <div class="historyListItemR">
                        <div class="year">{{item.year}}</div>
                        <div class="text">
                            <div>{{item.one}}</div>
                            <div>{{item.two}}</div>
                            <div>{{item.three}}</div>
                            <div>{{item.four}}</div>
                        </div>
                    </div>
                   
                </div>
                <div class="line"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active:10,
            list:[
                {year:'2021',one:'• 公司由“产品型”转换为“平台型”',two:'• 学院式开放共享型SaaS平台上线',three:'• 预计流量将突破100万'},
                {year:'2020',one:'• 《民法典》课程上线”',two:'  • 融e学app上线',three:'• 被广东省、深圳市、武汉市发文列为职业提升推荐平台'},
                {year:'2019',one:'• 获得国家高新技术企业认定',two:' • 企业商学院服务模式成熟并与国家电网、中 铁十一局、华润集团、中国电子集团深度合作'},
                {year:'2018',one:'• 2018高校创新创业产教融合高峰论坛举办',two:'• 多门课程获国家精品在线课程',three:'• 福田商学院上线，并入选民生事宜'},
                {year:'2017',one:'• 创新创业分享会举办',two:'• 创业管理本科专业、二学位启动',three:'• 系列创业、职业、资本课程上线',four:'• 管理者思维系列课程上线'},
                {year:'2016',one:'• 长江互联网研究院成立',two:'• 高校互联网教育与创新创业教育论坛举办',three:'• 《创新思维与创业逻辑》教材出版'},
                {year:'2015',one:'• 中潮教育应运而生',two:'• 融e学平台上线',three:'• 第一门课程《创业·道与术》上线'},
            ]
        };
    },
    created() {

    },
    methods: {

    }
};
</script>
+
<style scoped lang="scss">
.history{
    .coverBgc{
        height: 320px;
        position: relative;
        .titleText{
            width: 52%;
            position: absolute;
            top: 25px;
            left: 63px;
            color: #fff;
        }
        .title{
            font-size: 42px;
            font-weight: 500;
            padding: 10px 0;
            border-bottom:  1px solid #fff;
        }
        .explain{
            font-weight: 400;
            font-size: 16px;
            margin-top: 20px;
        }
    }
    .historyContent{
        padding: 29px 15px 0 44px;
        .historyTitle{
            font-size: 36px;
            color: #242424;
            font-weight: 500;
            text-align: center;
        }
        .historyList{
            position: relative; 
            margin-top: 20px;
            .historyListItem{
                position: relative;
                z-index: 5;
                display: flex;
                align-items: center;
                font-size: 21px;
                box-sizing: border-box;
                margin-bottom: 30px;
                .historyListItemImg{
                    width: 60px;
                    height: 60px; 
                }
                .historyListItemR{
                    flex: 1;
                    min-width: 0;
                    margin-left: 30px;
                    margin-right: 30px;
                    padding: 20px;
                    box-shadow: 0 5px 16px rgba(0,0,0,0.09), 0 0 5px rgba(0,0,0,0.09), 0 0 5px rgba(0,0,0,0.09); 
                }
                .year{
                    font-size: 42px;
                    color: #0e50b2;
                    font-weight: 700;
                }
                .text{
                    font-size: 21px;
                    color: #444;
                    line-height: 30px;
                    margin-top: 25px;
                }
            }
            .line{
                position: absolute;
                top: 0;
                left: 28px;
                width: 2px;
                height: 100%;
                background: #8d8d8d;
                z-index: 2;
            }
        }
    }
    img{
        width: 100%;
        height: 100%;
    }
    
}
</style>
